import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DownloadsOverviewContainerComponent } from './containers/downloads-overview-container/downloads-overview-container.component';

const routes: Routes = [
    {
        path: '',
        component: DownloadsOverviewContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DownloadsRoutingModule {}
